import { ENV_CONFIG } from '../config/environment';

function getAuthToken() {
  return (
    localStorage.getItem('token') ||
    localStorage.getItem('planillas_sanctum_token') ||
    localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY)
  );
}

/**
 * Firma del empleador en base64 (data URI) para PDFs — misma API que PlanillaDetalle.
 */
export async function obtenerFirmaEmpresaBase64(empresaId) {
  if (!empresaId) return null;
  try {
    const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/get-firma-base64/${empresaId}`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        Accept: 'application/json',
      },
    });
    if (!response.ok) return null;
    const result = await response.json();
    return result.success && result.firma_base64 ? result.firma_base64 : null;
  } catch {
    return null;
  }
}
